import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import getChatWidgetIdForDidNotFind from 'app/helpers/library/getChatWidgetIdForDidNotFind';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import DidNotFindExpandablePanel from './DidNotFindExpandablePanel';

const DidNotFindExpandablePanelContainer = ({ query }) => {
  const currentLibrary = useSelector(selectCurrentLibrary);

  const didNotFindOptions = currentLibrary.get('didNotFindOptions');
  if (!didNotFindOptions.get('isEnabled')) {
    return null;
  }

  const chatWidgetId = getChatWidgetIdForDidNotFind(currentLibrary);

  return <DidNotFindExpandablePanel chatWidgetId={chatWidgetId} didNotFindOptions={didNotFindOptions} query={query} />;
};

DidNotFindExpandablePanelContainer.propTypes = {
  query: PropTypes.string.isRequired
};

export default DidNotFindExpandablePanelContainer;
